/* eslint-disable */
//tslint:disable
export var EStatus;

(function (EStatus) {
  EStatus["Ok"] = "ok";
})(EStatus || (EStatus = {}));